// extracted by mini-css-extract-plugin
export default {"card":"H1-z"};